import { render } from "./Poster.vue?vue&type=template&id=98b12128&scoped=true"
import script from "./Poster.vue?vue&type=script&lang=js"
export * from "./Poster.vue?vue&type=script&lang=js"

import "./Poster.vue?vue&type=style&index=0&id=98b12128&scoped=true&lang=scss"

import exportComponent from "/Users/jiangxin/xhw/outer-h5-gwj-nft-website-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b12128"]])

export default __exports__